import { render } from "./CounterpartyJuridicalPersonForm.vue?vue&type=template&id=0b15edf4"
import script from "./CounterpartyJuridicalPersonForm.vue?vue&type=script&lang=js"
export * from "./CounterpartyJuridicalPersonForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__